
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TFilterDate, TFilterMultiSelect, TFilterTime } from '@/common/components/redesigned/Filter/types/filter';
  import TableWithOuterFilter from '@/common/components/redesigned/Table/TableWithOuterFilter.vue';
  import type { TTableWithOuterFilterConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TDictionary, TTitleDictionary } from '@/common/types/dictionary';

  import { TEventLogItem } from '@/modules/admin/types/eventLogs';
  import { TUserItem } from '@/modules/admin/types/users';

  import {
    EVENT_LOGS_ACTIONS_NAME,
    EVENT_LOGS_GETTERS_NAME,
    EVENT_LOGS_MUTATIONS_NAME,
  } from '../../../store/eventLogs/name';
  import { PERMISSIONS_ACTIONS_NAME, PERMISSIONS_GETTERS_NAME } from '../../../store/permissions/name';
  import { USERS_ACTIONS_NAME, USERS_GETTERS_NAME } from '../../../store/users/name';
  import { TPortalEventsUsersTableFilter } from '../../../types/statistics/statistics-portal';

  export default defineComponent({
    name: 'StatisticsPortalEventsUsersTable',
    components: {
      TableWithOuterFilter,
    },
    data(): {
      tableConfig: TTableWithOuterFilterConfig<TEventLogItem>;
      filter: Partial<TPortalEventsUsersTableFilter>;
    } {
      return {
        tableConfig: {
          columns: [
            {
              field: 'id',
              title: 'ID',
              width: 96,
            },
            {
              field: 'severityName',
              title: 'Критичность',
              width: 120,
            },
            {
              field: 'moduleName',
              title: 'Модуль',
              width: 266,
            },
            {
              field: 'permissionName',
              title: 'Действие',
              width: 148,
            },
            {
              field: 'userName',
              title: 'Пользователь',
              width: 266,
            },
            {
              field: 'formattedDate',
              title: 'Дата и время',
              width: 118,
            },
            {
              field: 'entityTypeName',
              title: 'Сущность',
              width: 250,
            },
          ],
          storePaths: {
            action: EVENT_LOGS_ACTIONS_NAME.getEventLogs,
            mutation: EVENT_LOGS_MUTATIONS_NAME.setEventLogs,
            getter: EVENT_LOGS_GETTERS_NAME.getEventLogs,
          },
        },
        filter: {},
      };
    },
    created() {
      this.loadDictionaries();
    },
    computed: {
      ...mapGetters({
        severities: EVENT_LOGS_GETTERS_NAME.getSeverities,
        modules: EVENT_LOGS_GETTERS_NAME.getModules,
        entityTypes: EVENT_LOGS_GETTERS_NAME.getEntityTypes,
        permissions: PERMISSIONS_GETTERS_NAME.getPermissions,
        users: USERS_GETTERS_NAME.getUsers,
      }),
      getFiltersConfig(): [
        TFilterMultiSelect<TTitleDictionary>,
        TFilterMultiSelect<TTitleDictionary>,
        TFilterMultiSelect<TDictionary>,
        TFilterMultiSelect<TUserItem>,
        TFilterDate,
        TFilterTime,
        TFilterMultiSelect<TTitleDictionary>,
      ] {
        return [
          {
            type: 'multi-select',
            label: 'Критичность',
            options: this.severities,
            valueProp: 'id',
            labelProp: 'title',
            vModel: 'severityIds',
            placeholder: 'Все',
          },
          {
            type: 'multi-select',
            label: 'Модуль',
            options: this.modules,
            valueProp: 'id',
            labelProp: 'title',
            vModel: 'moduleIds',
            placeholder: 'Все',
          },
          {
            type: 'multi-select',
            label: 'Действие',
            options: this.permissions,
            valueProp: 'id',
            labelProp: 'name',
            vModel: 'permissionIds',
            placeholder: 'Все',
            filters: [
              {
                source: 'moduleIds',
                key: 'moduleId',
              },
              {
                source: 'entityTypeIds',
                key: 'entityTypeId',
              },
            ],
          },
          {
            type: 'multi-select',
            label: 'Пользователь',
            options: this.users,
            valueProp: 'userId',
            labelProp: 'fullName',
            placeholder: 'Все',
            vModel: 'userIds',
          },
          {
            type: 'date',
            label: 'Дата',
            vModel: 'date',
          },
          {
            type: 'time',
            label: 'Время',
            vModel: 'time',
          },
          {
            type: 'multi-select',
            label: 'Сущность',
            options: this.entityTypes,
            valueProp: 'id',
            labelProp: 'title',
            vModel: 'entityTypeIds',
            placeholder: 'Все',
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        getSeverities: EVENT_LOGS_ACTIONS_NAME.getSeverities,
        getModules: EVENT_LOGS_ACTIONS_NAME.getModules,
        getEntityTypes: EVENT_LOGS_ACTIONS_NAME.getEntityTypes,
        getPermissions: PERMISSIONS_ACTIONS_NAME.getPermissions,
        getUsers: USERS_ACTIONS_NAME.getUsers,
      }),
      loadDictionaries() {
        this.getSeverities();
        this.getModules();
        this.getEntityTypes();
        this.getPermissions();
        this.getUsers();
      },
    },
  });
